import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Carrier from "./Carrier";
import AirportDeparture from "./AirportDeparture ";
import AirportDestination from "./AirportDestination ";
import TimeDeparture from "./TimeDeparture";
import TimeArrival from "./TimeArrival";
import { classList } from "@utils";

import DateArrival from "./DateArrival";
import DateDept from "./DateDept";
import { MdDelete } from "react-icons/md";

const FlightLegs = ({
  index,
  values,
  touched,
  errors,
  handleChange,

  tripType,
  arrayHelpers,
  setFieldValue,
  array,
}) => {
  return (
    <>
      {index > 0 && <hr />}
      <Row
        style={{
          //  backgroundColor: "#e4ffff"  ,
          marginBottom: 8,
        }}
      >
        {index != 0 && (
          <Col>
            <div style={{ fontSize: 15, fontWeight: "bold" }}>
              Stops -{index}
            </div>
          </Col>
        )}
        {/* disabled={index == array.length - 1 ? false : true} */}
        {index > 0 && (
          <Col xs="6">
            {index == array.length - 1 && (
              <div className="d-flex justify-content-end ">
                <Button
                  variant="danger"
                  type="button"
                  onClick={() => {
                    arrayHelpers.remove(index);
                  }}
                >
                  <MdDelete color="white" size={20} />
                </Button>
              </div>
            )}
          </Col>
        )}
      </Row>
      <Row>
        {/* <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group controlId="formBasicEmail">
            <Form.Label className="heading">
              Supplier<span className="text-danger">*</span>
            </Form.Label>
            <input
              className="form-control"
              type="text"
              placeholder=""
              name={`flightLegs.onward[${index}].supplier`}
              value={values?.flightLegs?.onward[index]?.supplier || ""}
              onChange={handleChange}
            />
            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched?.flightLegs?.onward[index]?.supplier &&
            errors?.flightLegs?.onward[index]?.supplier ? (
              <div className="error-label"></div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col> */}
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "4" : "4"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Airlines<span className="text-danger">*</span>
            </Form.Label>

            <Carrier
              index={index}
              value={values?.flightLegs?.onward[index]?.airline || ""}
              onChange={handleChange}
              touched={touched?.flightLegs?.onward[index]?.airline}
              setFieldValue={setFieldValue}
            />

            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched?.flightLegs?.onward[index]?.airline &&
            errors?.flightLegs?.onward[index]?.airline ? (
              <div className="error-label">
                {errors?.flightLegs?.onward[index]?.airline}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "4" : "4"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Flight Number<span className="text-danger">*</span>
            </Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="Flight Number"
              name={`flightLegs.onward[${index}].fN`}
              value={values?.flightLegs?.onward[index]?.fN || ""}
              onChange={handleChange}
            />
            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched.flightLegs?.onward[index]?.fN &&
            errors?.flightLegs?.onward[index]?.fN ? (
              <div className="error-label">
                {errors?.flightLegs?.onward[index]?.fN}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "4" : "4"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              PNR<span className="text-danger">*</span>
            </Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="PNR"
              name={`flightLegs.onward[${index}].pnr`}
              value={values?.flightLegs?.onward[index]?.pnr || ""}
              onChange={handleChange}
            />
            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched?.flightLegs?.onward[index]?.pnr &&
            errors?.flightLegs?.onward[index]?.pnr ? (
              <div className="error-label">
                {errors?.flightLegs?.onward[index]?.pnr}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Airport Departure<span className="text-danger">*</span>
            </Form.Label>

            <AirportDeparture index={index} setFieldValue={setFieldValue} />

            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched.flightLegs?.onward[index]?.airportDepartureId &&
            errors?.flightLegs?.onward[index]?.airportDepartureId ? (
              <div className="error-label">
                {errors?.flightLegs?.onward[index]?.airportDepartureId}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Airport Destination<span className="text-danger">*</span>
            </Form.Label>

            <AirportDestination index={index} setFieldValue={setFieldValue} />

            {touched?.flightLegs?.onward &&
            touched.flightLegs.onward[index]?.airportDestinationId &&
            errors?.flightLegs?.onward &&
            errors.flightLegs.onward[index]?.airportDestinationId ? (
              <div className="error-label">
                {errors?.flightLegs?.onward[index]?.airportDestinationId}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Departure Date<span className="text-danger">*</span>{" "}
            </Form.Label>
            <Row style={{ marginTop: -20, marginBottom: -20 }}>
              <DateDept
                index={index}
                values={values}
                handleChange={handleChange}
                touched={touched}
                errors={errors}
              />
            </Row>
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Arrival Date<span className="text-danger">*</span>
            </Form.Label>
            <Row style={{ marginTop: -20, marginBottom: -20 }}>
              <DateArrival
                index={index}
                values={values}
                handleChange={handleChange}
                touched={touched}
                errors={errors}
              />
            </Row>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Time Departure<span className="text-danger">*</span>
            </Form.Label>
            <TimeDeparture
              index={index}
              values={values}
              handleChange={handleChange}
            />
            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched?.flightLegs?.onward[index]?.departureTime &&
            errors?.flightLegs?.onward[index]?.departureTime ? (
              <div className="error-label">
                {errors?.flightLegs?.onward[index]?.departureTime}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Time Arrival<span className="text-danger">*</span>
            </Form.Label>
            <TimeArrival
              index={index}
              values={values}
              handleChange={handleChange}
            />
            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched?.flightLegs?.onward[index]?.arrivalTime &&
            errors?.flightLegs?.onward[index]?.arrivalTime ? (
              <div className="error-label">
                {errors?.flightLegs?.onward[index]?.arrivalTime}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>

        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "12" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">GDS PNR</Form.Label>

            <input
              className="form-control"
              type="text"
              placeholder="GDS PNR"
              name={`flightLegs.onward[${index}].gdsPnr`}
              value={values.flightLegs.onward[index].gdsPnr || ""}
              onChange={handleChange}
            />
            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched?.flightLegs?.onward[index]?.gdsPnr &&
            errors?.flightLegs?.onward[index]?.gdsPnr ? (
              <div className="error-label">
                {errors?.flightLegs?.onward[index]?.gdsPnr}{" "}
                {/* {values?.flightLegs?.onward[index]?.gdsPnr} */}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default FlightLegs;
